export const TAG_FIELDS = [
    { id: 'title', name: '标题' },
    { id: 'filename', name: '文件名' },
    { id: 'artist', name: '艺术家' },
    { id: 'album', name: '专辑' },
    { id: 'albumartist', name: '专辑艺术家' },
    { id: 'album_type', name: '专辑类型' },
    { id: 'album_img', name: '专辑封面' },
    { id: 'genre', name: '流派' },
    { id: 'year', name: '年份' },
    { id: 'lyrics', name: '歌词' },
    { id: 'lyrics_file', name: '歌词文件' },
    { id: 'comment', name: '简介' },
    { id: 'description', name: '描述' },
    { id: 'discnumber', name: '光盘号' },
    { id: 'tracknumber', name: '音轨号' },
    { id: 'totaldiscs', name: '总光盘数' },
    { id: 'totaltracks', name: '总曲目数' },
    { id: 'composer', name: '作曲家' },
    { id: 'lyricist', name: '作词家' },
    { id: 'language', name: '语言' },
    { id: 'date', name: '日期' },
    { id: 'subtitle', name: '副标题' },
    { id: 'albumversion', name: '专辑版本' },
    { id: 'replaygain_track_gain', name: '曲目增益' },
    { id: 'replaygain_track_peak', name: '曲目峰值' },
    { id: 'replaygain_album_gain', name: '专辑增益' },
    { id: 'replaygain_album_peak', name: '专辑峰值' }
]
export const modifyListBatch =  [
    { id: 'title', name: '标题' },
    { id: 'artist', name: '艺术家' },
    { id: 'album', name: '专辑' },
    { id: 'albumartist', name: '专辑艺术家' },
    { id: 'album_img', name: '专辑封面' },
    { id: 'year', name: '年份' },
    { id: 'lyrics', name: '歌词' },
    { id: 'is_save_lyrics_file', name: '歌词(LRC文件)' },
    { id: 'discnumber', name: '光盘编号' },
    { id: 'tracknumber', name: '音轨号' },
    { id: 'composer', name: '作曲家' },
    { id: 'lyricist', name: '作词家' },
    { id: 'language', name: '语言' }
]
export const UPDATE_TAG_ACTIONS = [
    { id: 'is_save_lyrics_file', name: '导出 lrc', description: '将元数据中的歌词导出为 .lrc 文件', group: 'lyrics' },
    { id: 'is_import_lyrics_file', name: '导入 lrc', description: '将 .lrc 文件导入元数据中', group: 'lyrics' },
    { id: 'is_format_lyrics_time', name: '格式化歌词时间', description: '将歌词时间标签中的三位小数统一截断为两位', group: 'lyrics' },
    { id: 'is_save_album_cover', name: '导出图片', description: '将专辑封面导出为单独图片文件', group: 'image' },
    { id: 'is_import_album_cover', name: '导入图片', description: '从同目录图片文件导入封面', group: 'image' }
]

export const TIDY_FIELDS = [
    { id: 'title', name: '标题' },
    { id: 'artist', name: '艺术家' },
    { id: 'albumartist', name: '专辑艺术家' },
    { id: 'album', name: '专辑' },
    { id: 'album_type', name: '专辑类型' },
    { id: 'genre', name: '流派' },
    { id: 'language', name: '语言' },
    { id: 'tracknumber', name: '音轨号' },
    { id: 'discnumber', name: '光盘号' },
    { id: 'comment', name: '简介' },
    { id: 'original_filename', name: '原文件名' },
    { id: 'custom', name: '固定文本' }
]

export const FORMAT_OPTIONS = ['', 'mp3', 'wav', 'flac', 'wma', 'ogg']
export const INPUT_FORMAT_OPTIONS = ['flac', 'mp3', 'ape', 'wav', 'aiff', 'aif', 'tta', 'm4a', 'ogg', 'opus', 'wma', 'dsf', 'dff', 'wmv', 'dts', 'aac']
export const DEFAULT_TIDY_RULE_FORM = {
    is_clean_music: false,
    clean_format_priority: ['flac', 'mp3'],
    clean_size_rule: 'smaller',
    clean_bitrate_rule: 'none',
    clean_sample_rule: 'none',
    clean_name_rule: 'none',
    clean_delete_rule: 'delete'
}

export const BATCH_OPERATION_CATALOG = [
    {
        id: 'update_tags', display_name: '批量编辑', description: '批量写入标题、艺术家、专辑、歌词、封面等元数据。', category: 'metadata', risk_level: 'medium',
        params: [{ key: 'fields', type: 'tag-fields', label: '标签字段与值', default: {} }]
    },
    {
        id: 'auto_tag', display_name: '自动刮削', description: '根据文件名和现有元数据从标签源匹配并补全音乐信息。', category: 'metadata', risk_level: 'medium',
        params: [
            { key: 'mode', type: 'select', label: '匹配模式', default: 'simple', options: ['simple', 'normal', 'hard'] },
            { key: 'source_list', type: 'list', label: '标签源', default: ['netease', 'qmusic'] },
            { key: 'modify_list', type: 'list', label: '修改字段', default: ['artist', 'album', 'album_img', 'year', 'lyrics'] },
            { key: 'is_skip_tag', type: 'boolean', label: '跳过已有标签', default: true },
            { key: 'is_folder_album', type: 'boolean', label: '按文件夹识别专辑', default: false },
            { key: 'scrape_rate', type: 'number', label: '刮削速率', default: 1 }
        ]
    },
    { id: 'background_scrape', display_name: '后台刮削', description: '使用系统后台刮削配置处理当前勾选的文件。', category: 'metadata', risk_level: 'medium', params: [] },
    {
        id: 'tidy_folder', display_name: '整理文件', description: '按元数据字段重新整理目录层级，并可启用洗版规则。', category: 'file', risk_level: 'high',
        params: [
            { key: 'root_path', type: 'path', label: '整理后的根目录', default: '' },
            { key: 'dir_list', type: 'tidy-fields', label: '目录层级', default: [{ value: 'artist', value2: '' }, { value: 'album', value2: '' }] },
            { key: 'rule_form', type: 'json', label: '洗版规则', default: DEFAULT_TIDY_RULE_FORM },
        ]
    },
    { id: 'remove_null_folder', display_name: '删除文件夹', description: '按删除模式清理空文件夹或无音乐文件夹。', category: 'file', risk_level: 'high', params: [{ key: 'delete_mode', type: 'select', label: '删除模式', default: 'null', options: ['null', 'null_music', 'all'] }] },
    {
        id: 'format_music', display_name: '格式转换', description: '批量转换音频格式、比特率和采样率。', category: 'media', risk_level: 'medium',
        params: [
            { key: 'music_type', type: 'select', label: '输出格式', default: '', options: FORMAT_OPTIONS },
            { key: 'bit_rate', type: 'select', label: '比特率', default: '-1', options: ['-1', '32', '64', '96', '128', '160', '192', '224', '256', '320', 'custom'] },
            { key: 'bit_rate_custom', type: 'number', label: '自定义比特率', default: '' },
            { key: 'sample_rate', type: 'select', label: '采样率', default: '-1', options: ['-1', '11025', '22050', '44100', '48000', 'custom'] },
            { key: 'sample_rate_custom', type: 'number', label: '自定义采样率', default: '' },
            { key: 'is_keep_source', type: 'boolean', label: '保留源文件', default: true },
            { key: 'input_formats', type: 'list', label: '输入格式', default: [], options: INPUT_FORMAT_OPTIONS }
        ]
    },
    { id: 'split_cue', display_name: '分割音轨', description: '将 CUE 音轨文件分割成独立音乐文件。', category: 'media', risk_level: 'high', params: [{ key: 'is_delete_source', type: 'boolean', label: '删除源文件', default: false }, { key: 'target_format', type: 'select', label: '目标格式', default: '', options: FORMAT_OPTIONS }] },
    { id: 'import_music', display_name: '导入收藏', description: '将选中文件导入音乐收藏，并可跳过已存在文件。', category: 'media', risk_level: 'medium', params: [{ key: 'is_skip_exist', type: 'boolean', label: '跳过已入库文件', default: true }, { key: 'import_rate', type: 'number', label: '导入速率', default: 10 }] },
    { id: 'duplicate_check', display_name: '重复文件检查', description: '通过声纹或元数据检测重复音乐文件。', category: 'media', risk_level: 'low', params: [{ key: 'is_acoustid', type: 'boolean', label: '启用声纹重复校验', default: false }, { key: 'is_metadata_compare', type: 'boolean', label: '启用音乐元数据对比', default: false }] },
    { id: 'replay_gain', display_name: '回放增益', description: '扫描音频音量并写入回放增益标签。', category: 'media', risk_level: 'low', params: [{ key: 'mode', type: 'select', label: '处理模式', default: 'track', options: ['track', 'album'] }] },
    { id: 'generate_strm', display_name: '生成 STRM 文件', description: '为选中的音乐文件生成 STRM 流媒体文件。', category: 'media', risk_level: 'medium', params: [{ key: 'is_sign', type: 'boolean', label: '启用签名验证', default: false }, { key: 'save_dir', type: 'path', label: '保存目录', default: '' }] },
    { id: 'convert_chinese', display_name: '简繁体转换', description: '批量转换标签文本中的简体中文和繁体中文。', category: 'text', risk_level: 'low', params: [{ key: 'mode', type: 'select', label: '转换方向', default: 'sim2trad', options: ['sim2trad', 'trad2sim'] }, { key: 'fields', type: 'tag-list', label: '修改范围', default: ['title', 'artist', 'album'], options: TAG_FIELDS.map(item => item.id) }] },
    { id: 'split_filename', display_name: '拆分元数据', description: '用规则从文件名或文本字段提取元数据。', category: 'text', risk_level: 'medium', params: [{ key: 'extract_field', type: 'select', label: '提取源', default: 'filename', options: ['filename', 'title', 'lyrics'] }, { key: 'rule_list', type: 'rules', label: '拆分规则', default: [] }] },
    { id: 'replace_text', display_name: '替换文本', description: '批量替换元数据字段中的普通文本或正则匹配内容。', category: 'text', risk_level: 'low', params: [{ key: 'mode', type: 'select', label: '替换模式', default: 'text', options: ['text', 'regex'] }, { key: 'fields', type: 'tag-list', label: '修改范围', default: ['title', 'artist', 'album'], options: TAG_FIELDS.map(item => item.id) }, { key: 'replace_text_list', type: 'replace-list', label: '替换规则', default: [{ before: '', after: '' }] }] },
    { id: 'encoding_fix', display_name: '乱码修复', description: '检测并修复音乐标签中的常见字符编码乱码。', category: 'text', risk_level: 'medium', params: [{ key: 'fields', type: 'tag-list', label: '检测范围', default: ['title', 'artist', 'album'], options: TAG_FIELDS.map(item => item.id) }, { key: 'auto_detect_encoding', type: 'boolean', label: '自动检测编码', default: true }, { key: 'backup_original', type: 'boolean', label: '备份原始内容', default: false }] },
    { id: 'file_index', display_name: '文件索引', description: '增量或完整重建音乐文件索引。', category: 'system', risk_level: 'low', params: [{ key: 'mode', type: 'select', label: '索引类型', default: 'rebuild', options: ['incremental', 'rebuild'] }] }
]

export function getBatchOperationDefinition(id) {
    return BATCH_OPERATION_CATALOG.find(item => item.id === id) || null
}

export function createOperationParams(id) {
    const definition = getBatchOperationDefinition(id)
    return (definition?.params || []).reduce((params, field) => {
        params[field.key] = JSON.parse(JSON.stringify(field.default))
        return params
    }, {})
}
